import { FmlxChip } from 'fmlx-common-ui';
import React from 'react';
import { SEARCH_BAR_TARGET_LABELS } from '../../Context/types';
import styles from './SearchBarTargetChips.module.scss';
import { useSearchBarContext } from '../../Context/SearchBarContext';
import { SearchItemsTarget } from 'business/models/Models';

export const SearchBarTargetChips = () => {
  const { filters, updateFilters } = useSearchBarContext();

  const isChipSelected = (chip: SearchItemsTarget) => {
    return filters.targetTypes.includes(chip);
  };

  const handleChipSelection = (chip: SearchItemsTarget) => {
    updateFilters({
      targetTypes: isChipSelected(chip)
        ? filters.targetTypes.filter((target) => target !== chip)
        : [...filters.targetTypes, chip],
    });
  };

  const chipValues = Object.values(SearchItemsTarget).filter(
    (v) => typeof v === 'number' && SEARCH_BAR_TARGET_LABELS[v] != null,
  ) as SearchItemsTarget[];

  return (
    <>
      {chipValues.map((target: SearchItemsTarget) => (
        <div
          key={target}
          id={`search-bar-target-chips-item-${target}`}
          className={`${styles.searchTargetChip} ${
            isChipSelected(target) ? styles.searchTargetChipSelected : ''
          }`}
        >
          <FmlxChip
            size={FmlxChip.Size.SMALL}
            variant={FmlxChip.Variant.FILLED}
            label={SEARCH_BAR_TARGET_LABELS[target]}
            selected={isChipSelected(target)}
            onClick={() => handleChipSelection(target)}
            readOnly={false}
          />
        </div>
      ))}
    </>
  );
};
